import { StateMachine } from 'tower/util';
import BattleScene from 'tower/scenes/battle';
import Enemy, { EnemyState } from 'tower/scenes/battle/enemy';
import { HitOptions } from 'tower/types';
import Flame from '../flame';

export default class OldMan extends Enemy {
  constructor(
    scene: BattleScene,
    x: number,
    y: number,
    public variantType = 'green',
  ) {
    super(scene, x, y, 'enemies', 102, 'oldman', {
      hp: Infinity,
      solid: true,
      knockback: false,
    });
    this.body.setSize(12, 12);
  }

  makeStateMachine(scene: BattleScene): StateMachine<EnemyState> {
    return new StateMachine('idle', {
      idle: new OldManIdleState(scene, this),
    });
  }

  async hit(options: HitOptions) {
    super.hit(options);

    // Tell flames to get angry
    for (const possibleFlameObject of this.scene.currentRoom.misc.children) {
      const possibleFlame = possibleFlameObject as Flame;
      if (possibleFlame.miscType === 'flame') {
        possibleFlame.startBlasting();
      }
    }
  }
}

class OldManState extends EnemyState {
  declare enemy: OldMan;
}

class OldManIdleState extends OldManState {
  handleEntered() {
    this.enemy.setFrame(102);
  }
}
